import { SurgeryProcedureInterface } from '@components/RequestForm/SurgeryInformation/SurgeryInformationInterface';
import { TemplateApi } from '@interfaces/Procedure/TemplateApi';
import { NO_SURGEON_VALUE } from './constants';
import {
	transformDropdownOptionsToEquipmentApi
} from '@components/ProcedureForm/inputs/EquipmentMultiSelect/EquipmentMultiSelectTypeConverters';

export const surgeryProcedureToTemplateApiConverter = (surgProc: SurgeryProcedureInterface): TemplateApi  => {
	return {
		name: 'templateName' in surgProc && surgProc.templateName ? surgProc.templateName : '',
		procedureName: surgProc.procedureName,
		anesthesiaType: surgProc.anesthesiaType ? surgProc.anesthesiaType.map( option => option.value ) : [],
		comments: surgProc.additionalComments ? surgProc.additionalComments : '',
		cptCodes: (surgProc.cptCodes.entriesList && surgProc.cptCodes.entriesList.length) ? [...surgProc.cptCodes.entriesList] : [],
		implantsNeeded: (surgProc.implantsNeeded === 0 || surgProc.implantsNeeded === 1) ? (surgProc.implantsNeeded === 1) : undefined,
		modifierSide: surgProc.modifierSide || '',
		modifierApproach: surgProc.modifierApproach || '',
		otherEquipments: surgProc.otherEquipment ? surgProc.otherEquipment : '',
		surgeonId: (surgProc.surgeon && surgProc.surgeon !== NO_SURGEON_VALUE) ? surgProc.surgeon : undefined,
		vendor: surgProc.vendorName,
		robotic: surgProc.robotic,
		equipment: surgProc.equipment ? transformDropdownOptionsToEquipmentApi(surgProc.equipment) : [],
	};
};


